import React, { Component } from 'react'
import styled from 'styled-components';
import Img from 'gatsby-image';

import Header from '../components/Header';

export default class HomePageContentRenderType extends Component {

  render() {
    const { data } = this.props
    if (!data) return null

    const headline = data.headline ? data.headline : null
    // const subHeading = data.subHeading ? data.subHeading : null
    const body = data.body ? data.body.childMarkdownRemark.html : null
    const images = data.images ? data.images : null

    return (
      <Container>
        { headline ? <Header>{headline}</Header> : null }
        <div>
          {images && images.length ? <div><Img fluid={images[0].fluid} alt={images[0].description} /></div> : null}
          { body ? <div dangerouslySetInnerHTML={ {__html:body} }/> : null }
        </div>
      </Container>

    )
  }
}

const Container = styled.div`
  & > div {
    font-size: 1.3em;
    margin-top: 2em;
    display: flex;
    align-items: center;
    div {
      flex: 1 1 50%;
      padding: 3%;
      @media (max-width: ${props => props.theme.responsive.medium}) {
        flex: 0 0 100%;
      }
      strong {
        display: block;
        position: relative;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        font-size: 1.1em;
        margin-bottom: 1em;
        color: ${props => props.theme.colors.secondary};
        :after {
          position: absolute;
          content: "";
          width: 6em;
          height: 0.2em;
          z-index: -1;
          background-color: ${props => props.theme.colors.brandSecondary};
          bottom: -0.2em;
          left: -0.55em;
          margin-top: -5px;
        }
      }
    }
    @media (max-width: ${props => props.theme.responsive.medium}) {
      align-items: stretch;
    }
  }
  &:nth-of-type(even) {
    div {
      flex-direction: row-reverse;
      @media (max-width: ${props => props.theme.responsive.medium}) {
        flex-direction: column;
      }
    }
  }
  &:nth-of-type(odd) {
    div {
      flex-direction: row;
      @media (max-width: ${props => props.theme.responsive.medium}) {
        flex-direction: column;
      }
    }
  }
`
